import { render, staticRenderFns } from "./pcoreword.vue?vue&type=template&id=31dbaf25&scoped=true&"
import script from "./pcoreword.vue?vue&type=script&lang=js&"
export * from "./pcoreword.vue?vue&type=script&lang=js&"
import style0 from "./pcoreword.vue?vue&type=style&index=0&id=31dbaf25&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31dbaf25",
  null
  
)

export default component.exports